import authService from "../services/authService";
import styles from "./checkoutlayout.module.css";
import { Banner, BreadCrumb, Stepper, SubHeadingTitle } from "./shared/index";
import { Outlet, useLocation,useNavigate  } from "react-router-dom";

const CheckoutLayout = () => {
  const { pathname } = useLocation();
  const isLoggedin = authService.isLoggedIn();
  const location = useLocation();
    const navigate = useNavigate();

const fromBuyNow = location.state?.fromBuyNow;
 const steps = fromBuyNow
  ? [
      { number: 1, label: "Address Checkout" },
      { number: 2, label: "Shopping & Payment" },
      { number: 3, label: "Complete" },
    ]
  : [
      { number: 1, label: "Shopping Cart" },
      { number: 2, label: "Address Checkout" },
      { number: 3, label: "Shopping & Payment" },
      { number: 4, label: "Complete" },
    ];
 const currentStepMapping = fromBuyNow
  ? {
      checkout: 1,
      address: 1,
      payment: 2,
      success: 3,
      "order-success": 3,
    }
  : {
      cart: 1,
      checkout: 2,
      address: 2,
      payment: 3,
      success: 4,
      "order-success": 4,
    };

  const lastPart = pathname.split("/").pop();
  const currentStep = currentStepMapping[lastPart] || 1;

  const pageConfig = {
    cart: {
      breadcrumbLabel: "Shopping Cart",
      bannerHeading: "You're Almost There! Complete Your Purchase & Enjoy Fast Delivery",
      bannerImage:
        "https://t3.ftcdn.net/jpg/11/35/37/64/240_F_1135376490_RZNotAEJp21HAiSqt5x9ONVN9XKkKCVW.jpg",
    },
    checkout: {
      breadcrumbLabel: "Address Checkout",
      bannerHeading: "You're Almost There! Complete Your Purchase & Enjoy Fast Delivery", 
      bannerImage:
        "https://t3.ftcdn.net/jpg/03/20/68/66/240_F_320686681_Ur6vdYQgDC9WiijiVfxlRyQffxOgfeFz.jpg"
    },
    payment: {
      breadcrumbLabel: "Shipping & Payment Summary",
      bannerHeading: "The ultimate family fashion destination",
      bannerImage:
          "https://t3.ftcdn.net/jpg/03/11/18/52/240_F_311185297_Ga1gl6pGUDx9mRE4Cf9yuYc9nbWyJOBP.jpg",
    },
    success: {
      breadcrumbLabel: "Product Tracking",
      bannerHeading: "Same Day Delivery . multiple payment options",
      bannerImage:
        "https://t3.ftcdn.net/jpg/18/73/80/78/240_F_1873807891_FjRkkrMNeaIsJm0LLdWh2H0w1uCRs9Sy.jpg",
    },
       "order-success": { 
      breadcrumbLabel: "Product Tracking",
      bannerHeading: "Same Day Delivery . multiple payment options",
      bannerImage:
        "https://media.istockphoto.com/id/960871382/photo/assortment-of-the-fresh-vegetables.jpg?s=612x612&w=0&k=20&c=wUJcQBMWzoxwS_WNhCeoS0HaSMfS7IAHO_9uIg7WK0c=",
    },
  };

  const key = pathname.split("/").pop();
  const config = pageConfig[key] || pageConfig["checkout"];

  return (
    <div className={styles.checkoutWrapper}>
      <BreadCrumb
        customPaths={[{ label: config.breadcrumbLabel, path: "/" }]}
      />
      <Banner heading={config.bannerHeading} imageUrl={config.bannerImage} />
   {!isLoggedin ? (
  <div className={styles.loginRequired}>
    <SubHeadingTitle
      subTitle="Please login to check cart items & proceed to checkout."
      style={styles.cartError}
    />

    <button
      type="button"
      className={styles.loginButton}
      onClick={() => navigate("/login")}
    >
      Login
    </button>
  </div>
) : (
  <Outlet />
)}
    </div>
  );
};

export default CheckoutLayout;